import React, { createContext, useContext, useState, useEffect } from 'react';
import api from './api';

const ConfigContext = createContext({});

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({ mlIntegrationEnabled: false });

  useEffect(() => {
    api.get('/config/public')
      .then(res => setConfig(res.data))
      .catch(() => {});
  }, []);

  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}
